<div class="border-0 legacy-card">
  <div class="card-body px-0">
    <ul class="menu-grid list-unstyled">
      <li>
        <a class="d-flex align-items-center justify-content-start text-decoration-none text-dark text-xs fw-500" href="/feed">
          <img :src="home_feature_icons.feed" alt="Feeds" />
          <span class="link-name ms-2">Feeds</span>
        </a>
      </li>

      <li v-if="client_features.show_portals">
        <a class="text-dark" data-bs-toggle="offcanvas" href="#portals" role="button" aria-controls="portals">
          <img :src="home_feature_icons.portals" :alt="client_features.portals_label" />
          <span class="link-name fw-500 ms-2">{{ client_features.portals_label }}</span>
        </a>
      </li>

      <li v-if="client_features.show_library">
        <a class="d-flex align-items-center justify-content-start text-decoration-none text-dark text-xs fw-500" href="/library">
          <img :src="home_feature_icons.library" alt="Library" />
          <span class="ms-2">Library</span>
        </a>
      </li>

      <li class="d-none">
        <a href="/view_group" class="d-flex align-items-center justify-content-start text-decoration-none text-dark text-xs fw-500">
          <img :src="home_feature_icons.groups" alt="Groups" />
          <span class="link-name ms-2">Groups</span>
        </a>
      </li>

      <li v-if="client_features.show_events">
        <a href="/view_events" class="d-flex align-items-center justify-content-start text-decoration-none text-dark text-xs fw-500">
          <img :src="home_feature_icons.events" alt="Events" />
          <span class="link-name ms-2">Events</span>
        </a>
      </li>

      <li v-if="client_features.show_incident">
        <a class="d-flex align-items-center justify-content-start text-decoration-none text-gray text-xs fw-500" href="/incident_reporting">
          <img :src="home_feature_icons.incident_reporting" alt="Incidents" />
          <span class="link-name ms-2">Incidents</span>
        </a>
      </li>

      <li v-if="client_features.show_assets">
        <a class="d-flex align-items-center justify-content-start text-decoration-none text-dark text-xs fw-500" href="/community_asset">
          <img :src="home_feature_icons.assets" alt="Assets" />
          <span class="link-name ms-2">Assets</span>
        </a>
      </li>

      <li v-if="token_exists && client_features.show_donations">
        <a class="d-flex align-items-center justify-content-start text-decoration-none text-dark text-xs fw-500" href="/donation_campaigns">
          <img :src="home_feature_icons.donations" alt="Donations" />
          <span class="link-name ms-2">Donations</span>
        </a>
      </li>

      <li v-if="client_features.show_marketplace">
        <a class="d-flex align-items-center justify-content-start text-decoration-none text-dark text-xs fw-500" href="/marketplace">
          <img :src="home_feature_icons.marketplace" alt="Marketplace" />
          <span class="link-name ms-2">Marketplace</span>
        </a>
      </li>
      <li v-if="token_exists && client_features.show_marketplace">
        <a class="d-flex align-items-center justify-content-start text-decoration-none text-dark text-xs fw-500" href="/my_shop">
          <img :src="home_feature_icons.products" alt="My Shop" />
          <span class="link-name ms-2">My Shop</span>
        </a>
      </li>
      <li v-if="token_exists && client_features.show_marketplace">
        <a class="d-flex align-items-center justify-content-start text-decoration-none text-dark text-xs fw-500" href="/my_services">
          <img :src="home_feature_icons.services" alt="My Services" />
          <span class="link-name ms-2">My Services</span>
        </a>
      </li>
      <li v-if="client_features.show_marketplace">
        <a class="d-flex align-items-center justify-content-start text-decoration-none text-dark text-xs fw-500" href="/my_orders">
          <img :src="home_feature_icons.products" alt="My Orders" />
          <span class="link-name ms-1">My Orders</span>
        </a>
      </li>

      <li class="d-none" v-if="client_features.show_services">
        <a class="d-flex align-items-center justify-content-start text-decoration-none text-dark text-xs fw-500" href="/create_service">
          <img :src="home_feature_icons.services" alt="Services" />
          <span class="ms-2">Services</span>
        </a>
      </li>
      <li>
        <a href="/dashboard" v-if="token_exists && (user_details.user_role == 'admin' || user_details.user_role == 'organization admin')" class="d-flex align-items-center justify-content-start text-decoration-none text-dark text-xs fw-500">
          <img :src="home_feature_icons.dashboard" alt="Dashboard" />
          <span class="link-name ms-2">Dashboard</span>
        </a>
      </li>

    </ul>
  </div>
</div>
